import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
button:focus-visible,
input:focus-visible,
select:focus-visible,
summary:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

:host {
  display: block;
  min-height: 100%;
}

.product-page {
  min-height: 100%;
  background: #f5f7fb;
  color: #1e293b;
}

.product-header {
  position: sticky;
  z-index: 40;
  top: 0;
  border-bottom: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(14px);
}

.brand-icon {
  display: flex;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #0f172a;
  color: #67e8f9;
}

.safe-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  background: #ecfdf5;
  padding: 0.4rem 0.7rem;
  color: #047857;
  font-size: 9px;
  font-weight: 700;
}

.safe-badge i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
}

.reset-button {
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: white;
  padding: 0.45rem 0.7rem;
  color: #475569;
  font-size: 9px;
  font-weight: 700;
}

.reset-button:hover {
  border-color: #94a3b8;
  color: #0f172a;
}

.intro-panel {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  overflow: hidden;
  border-radius: 20px;
  background: radial-gradient(circle at 92% 10%, rgba(34, 211, 238, 0.18), transparent 23rem), linear-gradient(120deg, #0f172a, #172554);
  padding: 2rem;
  color: white;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.15);
}

.intro-label {
  display: inline-flex;
  border: 1px solid rgba(103, 232, 249, 0.3);
  border-radius: 999px;
  background: rgba(34, 211, 238, 0.09);
  padding: 0.35rem 0.7rem;
  color: #67e8f9;
  font-size: 9px;
  font-weight: 700;
}

.intro-panel h2 {
  margin-top: 0.8rem;
  font-size: clamp(1.55rem, 3.5vw, 2.25rem);
  font-weight: 800;
  letter-spacing: -0.035em;
  line-height: 1.2;
}

.intro-panel > div > p {
  max-width: 630px;
  margin-top: 0.8rem;
  color: #cbd5e1;
  font-size: 11px;
  line-height: 1.7;
}

.hero-network {
  width: min(100%, 480px);
  min-width: 430px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 18px;
  background: rgba(2, 6, 23, 0.48);
  padding: 1.1rem;
  box-shadow: inset 0 1px rgba(255, 255, 255, 0.04);
}

.hero-network-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.hero-network-title span {
  color: #67e8f9;
  font-size: 9px;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.hero-network-title strong {
  color: #cbd5e1;
  font-size: 9px;
  font-weight: 600;
}

.hero-flow {
  display: grid;
  grid-template-columns: 1fr 32px 1fr 32px 1fr;
  align-items: center;
  margin-top: 1rem;
}

.hero-endpoint,
.hero-firewall {
  display: grid;
  min-height: 86px;
  align-content: center;
  justify-items: center;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.72);
  padding: 0.65rem 0.45rem;
  text-align: center;
}

.hero-endpoint span {
  border-radius: 6px;
  background: #334155;
  padding: 0.25rem 0.4rem;
  color: #94a3b8;
  font-size: 7px;
  font-weight: 750;
}

.hero-endpoint strong,
.hero-firewall strong {
  margin-top: 0.45rem;
  color: #e2e8f0;
  font-size: 9px;
}

.server-endpoint {
  border-color: rgba(96, 165, 250, 0.35);
}

.hero-firewall {
  border-color: rgba(103, 232, 249, 0.35);
  color: #67e8f9;
}

.hero-firewall.ready {
  border-color: rgba(52, 211, 153, 0.55);
  color: #6ee7b7;
  box-shadow: 0 0 24px rgba(16, 185, 129, 0.1);
}

.hero-shield {
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: rgba(34, 211, 238, 0.1);
}

.hero-firewall small {
  margin-top: 0.25rem;
  color: #94a3b8;
  font-size: 7px;
}

.hero-connector {
  position: relative;
  height: 1px;
  background: #475569;
}

.hero-connector::after {
  position: absolute;
  top: 50%;
  right: -1px;
  width: 6px;
  height: 6px;
  border-top: 1px solid #64748b;
  border-right: 1px solid #64748b;
  content: "";
  transform: translateY(-50%) rotate(45deg);
}

.hero-connector i {
  position: absolute;
  top: -2px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #22d3ee;
  box-shadow: 0 0 8px #22d3ee;
  animation: hero-packet 2.2s linear infinite;
}

.hero-policy-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.45rem;
  margin-top: 0.85rem;
}

.hero-policy-row span {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.64);
  padding: 0.3rem 0.5rem;
  color: #cbd5e1;
  font-size: 7px;
}

.hero-policy-row i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.allow-dot {
  background: #22c55e;
}

.limit-dot {
  background: #38bdf8;
}

.deny-dot {
  background: #fb7185;
}

.command-center {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(260px, 0.55fr);
  gap: 1px;
  overflow: hidden;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  background: #dbe4f0;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.07);
}

.command-primary,
.security-score-card,
.security-check-grid {
  background: white;
}

.command-primary {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 1rem;
  min-height: 148px;
  padding: 1.2rem 1.3rem;
}

.command-step {
  display: grid;
  width: 68px;
  height: 78px;
  align-content: center;
  justify-items: center;
  border-radius: 14px;
  background: #0f172a;
  color: white;
}

.command-step span {
  color: #94a3b8;
  font-size: 7px;
  font-weight: 700;
}

.command-step strong {
  margin-top: 0.2rem;
  color: #67e8f9;
  font-size: 25px;
  line-height: 1;
}

.command-step small {
  margin-top: 0.1rem;
  color: #64748b;
  font-size: 8px;
}

.command-copy {
  min-width: 0;
}

.command-kicker,
.section-eyebrow {
  color: #2563eb;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.command-copy h2 {
  margin-top: 0.35rem;
  color: #0f172a;
  font-size: 15px;
  font-weight: 780;
  letter-spacing: -0.02em;
}

.command-copy > p {
  max-width: 620px;
  margin-top: 0.35rem;
  color: #64748b;
  font-size: 9px;
  line-height: 1.55;
}

.command-live {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.65rem;
  color: #475569;
  font-size: 8px;
}

.command-live i {
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #3b82f6;
  box-shadow: 0 0 0 4px #dbeafe;
}

.command-button {
  display: inline-flex;
  min-width: 125px;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 11px;
  background: #2563eb;
  padding: 0 0.9rem;
  color: white;
  font-size: 9px;
  font-weight: 750;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease;
}

.command-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 11px 23px rgba(37, 99, 235, 0.25);
}

.command-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.security-score-card {
  min-height: 148px;
  padding: 1.2rem;
}

.score-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.score-heading span,
.score-heading strong {
  display: block;
}

.score-heading span {
  color: #64748b;
  font-size: 8px;
}

.score-heading strong {
  margin-top: 0.25rem;
  color: #0f172a;
  font-size: 12px;
}

.score-heading b {
  color: #2563eb;
  font-size: 24px;
  line-height: 1;
}

.score-heading b small {
  color: #94a3b8;
  font-size: 8px;
  font-weight: 600;
}

.score-track {
  height: 7px;
  margin-top: 1rem;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}

.score-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2563eb, #10b981);
  transition: width 0.35s ease;
}

.security-score-card p {
  margin-top: 0.7rem;
  color: #64748b;
  font-size: 8px;
  line-height: 1.5;
}

.security-check-grid {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
}

.security-check {
  display: grid;
  grid-template-columns: 26px 1fr auto;
  align-items: center;
  gap: 0.55rem;
  min-height: 72px;
  padding: 0.8rem 1rem;
}

.check-mark {
  display: flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f1f5f9;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 800;
}

.security-check strong,
.security-check small {
  display: block;
}

.security-check strong {
  color: #334155;
  font-size: 8px;
}

.security-check small {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 7px;
  line-height: 1.35;
}

.security-check em {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 0.25rem 0.45rem;
  color: #64748b;
  font-size: 7px;
  font-style: normal;
  font-weight: 700;
}

.security-check.pass .check-mark {
  background: #dcfce7;
  color: #15803d;
}

.security-check.pass em {
  background: #ecfdf5;
  color: #047857;
}

.command-idle {
  border-color: #dbe4f0;
}

.command-ready {
  border-color: #bfdbfe;
  background: #bfdbfe;
}

.command-ready .command-step {
  background: #1e3a8a;
}

.command-safe {
  border-color: #a7f3d0;
  background: #a7f3d0;
}

.command-safe .command-step {
  background: #064e3b;
}

.command-safe .command-live i {
  background: #10b981;
  box-shadow: 0 0 0 4px #d1fae5;
}

.rose-text {
  color: #e11d48;
}

.policy-builder {
  border-color: #bfdbfe;
  background: linear-gradient(135deg, white, #f8fbff);
}

.policy-builder.policy-ready {
  border-color: #86efac;
  background: linear-gradient(135deg, white, #f6fff9);
}

.status-ready {
  background: #eff6ff;
  color: #1d4ed8;
}

.status-ready i {
  background: #3b82f6;
}

.policy-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(330px, 0.92fr);
  gap: 1rem;
  margin-top: 1rem;
}

.policy-form,
.rule-preview {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: white;
  padding: 1rem;
}

.policy-form h3,
.rule-preview h3 {
  color: #0f172a;
  font-size: 12px;
  font-weight: 750;
}

.policy-input-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.7rem;
  margin-top: 0.75rem;
}

.policy-input-grid label > span,
.policy-input-grid label > small {
  display: block;
}

.policy-input-grid label > span {
  margin-bottom: 0.4rem;
  color: #334155;
  font-size: 9px;
  font-weight: 700;
}

.policy-input-grid input,
.policy-input-grid select {
  width: 100%;
  height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #f8fafc;
  padding: 0 0.7rem;
  color: #0f172a;
  font-size: 11px;
  outline: none;
}

.policy-input-grid input:focus,
.policy-input-grid select:focus {
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.policy-input-grid input:disabled,
.policy-input-grid select:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.policy-input-grid label > small {
  margin-top: 0.35rem;
  color: #94a3b8;
  font-size: 8px;
}

.policy-safeguards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.45rem;
  margin-top: 0.8rem;
}

.policy-safeguards > div {
  border: 1px solid #dbeafe;
  border-radius: 9px;
  background: #eff6ff;
  padding: 0.55rem 0.65rem;
}

.policy-safeguards strong,
.policy-safeguards span {
  display: block;
}

.policy-safeguards strong {
  color: #1e40af;
  font-size: 8px;
}

.policy-safeguards span {
  margin-top: 2px;
  color: #64748b;
  font-size: 7px;
}

.policy-errors {
  margin-top: 0.7rem;
  border: 1px solid #fecdd3;
  border-radius: 9px;
  background: #fff1f2;
  padding: 0.55rem 0.7rem;
}

.policy-errors p {
  color: #be123c;
  font-size: 8px;
  line-height: 1.6;
}

.rule-preview {
  min-height: 100%;
}

.rule-preview-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.7rem;
}

.rule-preview-title p {
  margin-top: 3px;
  color: #64748b;
  font-size: 8px;
}

.rule-preview-title > span {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 0.3rem 0.55rem;
  color: #475569;
  font-size: 8px;
  font-weight: 700;
}

.rule-empty {
  display: flex;
  min-height: 190px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 0.75rem;
  border: 1px dashed #cbd5e1;
  border-radius: 11px;
  background: #f8fafc;
  text-align: center;
}

.rule-empty strong {
  color: #475569;
  font-size: 9px;
}

.rule-empty p {
  max-width: 260px;
  margin-top: 4px;
  color: #94a3b8;
  font-size: 7px;
  line-height: 1.5;
}

.rule-card {
  display: grid;
  grid-template-columns: 28px 1fr auto;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.55rem;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  background: #f0fdf4;
  padding: 0.6rem;
}

.rule-card.deny-rule {
  border-color: #fecdd3;
  background: #fff1f2;
}

.rule-index {
  display: flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #059669;
  color: white;
  font-size: 8px;
  font-weight: 800;
}

.deny-rule .rule-index {
  background: #e11d48;
}

.rule-card strong,
.rule-card p,
.rule-card small {
  display: block;
}

.rule-card strong {
  color: #166534;
  font-size: 9px;
}

.deny-rule strong {
  color: #9f1239;
}

.rule-card p {
  margin-top: 2px;
  color: #334155;
  font-size: 8px;
}

.rule-card small {
  margin-top: 2px;
  color: #64748b;
  font-size: 7px;
}

.rule-action {
  border-radius: 999px;
  background: #dcfce7;
  padding: 0.25rem 0.45rem;
  color: #166534;
  font-size: 7px;
  font-weight: 750;
}

.deny-rule .rule-action {
  background: #ffe4e6;
  color: #9f1239;
}

.policy-meaning {
  margin-top: 0.65rem;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #eff6ff;
  padding: 0.65rem 0.75rem;
}

.policy-meaning strong {
  color: #1e40af;
  font-size: 9px;
}

.policy-meaning p {
  margin-top: 3px;
  color: #475569;
  font-size: 8px;
  line-height: 1.55;
}

.progress-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: white;
  padding: 1rem;
  box-shadow: 0 7px 22px rgba(15, 23, 42, 0.04);
}

.progress-step {
  display: flex;
  min-width: 130px;
  align-items: center;
  gap: 0.55rem;
}

.progress-step > span {
  display: flex;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #f8fafc;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
}

.progress-step strong,
.progress-step small {
  display: block;
}

.progress-step strong {
  color: #334155;
  font-size: 9px;
}

.progress-step small {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 7px;
}

.progress-step.complete > span {
  border-color: #6ee7b7;
  background: #ecfdf5;
  color: #047857;
}

.progress-step.current > span {
  border-color: #60a5fa;
  background: #eff6ff;
  color: #1d4ed8;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.08);
}

.progress-line {
  width: min(5vw, 62px);
  height: 2px;
  margin: 0 0.5rem;
  background: #e2e8f0;
}

.progress-line.complete {
  background: #6ee7b7;
}

.panel {
  position: relative;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: white;
  padding: 1.2rem;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.045);
}

.panel-header {
  display: flex;
  min-height: 48px;
  align-items: flex-start;
  gap: 0.7rem;
}

.panel-header > div:nth-child(2) {
  min-width: 0;
  flex: 1;
}

.panel-header h2 {
  color: #0f172a;
  font-size: 15px;
  font-weight: 750;
}

.panel-header p {
  margin-top: 4px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.45;
}

.step-tag {
  display: flex;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #0ea5e9;
  color: white;
  font-size: 10px;
  font-weight: 800;
}

.step-tag.indigo {
  background: #4f46e5;
}

.step-tag.violet {
  background: #8b5cf6;
}

.step-tag.emerald {
  background: #10b981;
}

.step-tag.rose {
  background: #e11d48;
}

.status-chip,
.count-chip {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.35rem;
  border-radius: 999px;
  padding: 0.35rem 0.6rem;
  font-size: 8px;
  font-weight: 700;
}

.status-chip i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-off {
  background: #f1f5f9;
  color: #64748b;
}

.status-off i {
  background: #94a3b8;
}

.status-on {
  background: #ecfdf5;
  color: #047857;
}

.status-on i {
  background: #10b981;
}

.count-chip {
  background: #f3e8ff;
  color: #7e22ce;
}

.count-chip.amber {
  margin-left: auto;
  background: #fffbeb;
  color: #b45309;
}

.server-visual {
  display: flex;
  min-height: 180px;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
  margin-top: 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: linear-gradient(rgba(148, 163, 184, 0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.06) 1px, transparent 1px), #f8fafc;
  background-size: 22px 22px;
}

.server-visual.online {
  border-color: #a7f3d0;
  background: linear-gradient(rgba(16, 185, 129, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(16, 185, 129, 0.05) 1px, transparent 1px), #f0fdf4;
  background-size: 22px 22px;
}

.server-stack {
  display: grid;
  gap: 6px;
}

.server-stack > span {
  display: flex;
  width: 92px;
  height: 28px;
  align-items: center;
  gap: 7px;
  border: 1px solid #94a3b8;
  border-radius: 6px;
  background: #334155;
  padding: 0 10px;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.12);
}

.server-stack i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #64748b;
}

.online .server-stack > span {
  border-color: #059669;
  background: #064e3b;
}

.online .server-stack i:first-child {
  background: #34d399;
  box-shadow: 0 0 8px #34d399;
}

.server-copy {
  max-width: 210px;
}

.server-copy strong {
  color: #1e293b;
  font-size: 11px;
}

.server-copy p {
  margin-top: 5px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.5;
}

.server-copy small {
  display: block;
  margin-top: 7px;
  color: #0f766e;
  font-size: 8px;
  font-weight: 650;
}

.primary-button,
.compact-button,
.attack-button {
  border-radius: 10px;
  font-weight: 700;
  transition: transform 0.16s ease, opacity 0.16s ease, box-shadow 0.16s ease;
}

.primary-button {
  width: 100%;
  min-height: 42px;
  margin-top: 0.8rem;
  font-size: 10px;
}

.primary-button:hover:not(:disabled),
.compact-button:hover:not(:disabled),
.attack-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.primary-button:disabled,
.compact-button:disabled,
.attack-button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.blue-button {
  background: #2563eb;
  color: white;
  box-shadow: 0 7px 16px rgba(37, 99, 235, 0.18);
}

.violet-button {
  background: #7c3aed;
  color: white;
  box-shadow: 0 7px 16px rgba(124, 58, 237, 0.16);
}

.danger-outline {
  border: 1px solid #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.user-grid {
  display: grid;
  min-height: 180px;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.55rem;
  margin-top: 0.8rem;
}

.user-card {
  display: flex;
  min-height: 76px;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid #d1fae5;
  border-radius: 12px;
  background: #f0fdf4;
  padding: 0.55rem;
  animation: user-enter 0.35s ease-out both;
}

.user-avatar {
  display: flex;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #0e7490;
  color: white;
  font-size: 9px;
  font-weight: 800;
}

.avatar-rose {
  background: #7c3aed;
}

.user-card strong,
.user-card small {
  display: block;
}

.user-card strong {
  color: #166534;
  font-size: 9px;
}

.user-card small {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-top: 2px;
  color: #16a34a;
  font-size: 7px;
}

.user-card small i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #22c55e;
}

.empty-user {
  border-style: dashed;
  border-color: #cbd5e1;
  background: #f8fafc;
  animation: none;
}

.empty-user .user-avatar {
  background: #e2e8f0;
  color: #94a3b8;
}

.empty-user strong,
.empty-user small {
  color: #94a3b8;
}

.inline-notice {
  margin-top: 0.55rem;
  border: 1px solid #a7f3d0;
  border-radius: 9px;
  background: #ecfdf5;
  padding: 0.5rem 0.7rem;
  color: #047857;
  font-size: 8px;
  font-weight: 650;
  text-align: center;
}

.compact-button {
  min-width: 145px;
  min-height: 38px;
  padding: 0 0.9rem;
  font-size: 9px;
}

.green-button {
  background: #059669;
  color: white;
  box-shadow: 0 6px 14px rgba(5, 150, 105, 0.16);
}

.arena {
  position: relative;
  height: 335px;
  margin-top: 0.8rem;
  overflow: hidden;
  border: 1px solid #334155;
  border-radius: 14px;
  background: radial-gradient(circle at 50% 50%, rgba(34, 211, 238, 0.08), transparent 28%), linear-gradient(90deg, rgba(6, 182, 212, 0.04) 0 50%, rgba(139, 92, 246, 0.04) 50%), #0f172a;
}

.arena-grid {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(148, 163, 184, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.07) 1px, transparent 1px);
  background-size: 28px 28px;
}

.arena.live {
  border-color: #10b981;
  box-shadow: inset 0 0 45px rgba(16, 185, 129, 0.07);
}

.arena.degraded {
  border-color: #e11d48;
  box-shadow: inset 0 0 50px rgba(225, 29, 72, 0.1);
}

.arena-center {
  position: absolute;
  top: 16px;
  bottom: 16px;
  left: 50%;
  border-left: 1px dashed rgba(148, 163, 184, 0.28);
}

.team-zone {
  position: absolute;
  z-index: 2;
  top: 50%;
  display: flex;
  width: 58px;
  height: 78px;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  border-radius: 10px;
  font-size: 7px;
  font-weight: 750;
  transform: translateY(-50%);
}

.team-left {
  left: 15px;
  border-color: rgba(34, 211, 238, 0.35);
  background: rgba(34, 211, 238, 0.08);
  color: #67e8f9;
}

.team-right {
  right: 15px;
  border-color: rgba(167, 139, 250, 0.35);
  background: rgba(139, 92, 246, 0.08);
  color: #c4b5fd;
}

.arena-user {
  position: absolute;
  z-index: 8;
  display: grid;
  width: 46px;
  justify-items: center;
  transform: translate(-50%, -50%);
  transition: top 0.72s ease, left 0.72s ease;
}

.arena-user > span {
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid #22d3ee;
  border-radius: 10px;
  background: #164e63;
  color: #cffafe;
  font-size: 9px;
  font-weight: 800;
  box-shadow: 0 7px 16px rgba(0, 0, 0, 0.28);
}

.arena-rose > span {
  border-color: #a78bfa;
  background: #4c1d95;
  color: #ede9fe;
}

.arena-user strong {
  margin-top: 3px;
  border-radius: 999px;
  background: rgba(2, 6, 23, 0.85);
  padding: 2px 5px;
  color: #e2e8f0;
  font-size: 7px;
}

.live .arena-user > span {
  animation: subtle-pulse 1.4s ease-in-out infinite alternate;
}

.arena-overlay {
  position: absolute;
  z-index: 20;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(15, 23, 42, 0.78);
  color: #e2e8f0;
  backdrop-filter: blur(3px);
}

.arena-overlay strong {
  font-size: 11px;
}

.arena-overlay p {
  margin-top: 5px;
  color: #94a3b8;
  font-size: 8px;
}

.arena-overlay.compact {
  inset: auto;
  top: 12px;
  left: 50%;
  width: max-content;
  border: 1px solid #475569;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.94);
  padding: 0.45rem 0.75rem;
  transform: translateX(-50%);
}

.arena-overlay.compact strong {
  font-size: 8px;
}

.arena-overlay.compact p {
  margin: 0 0 0 6px;
  display: inline;
  font-size: 7px;
}

.live-label {
  position: absolute;
  z-index: 15;
  top: 12px;
  left: 50%;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid rgba(52, 211, 153, 0.35);
  border-radius: 999px;
  background: rgba(6, 78, 59, 0.9);
  padding: 0.4rem 0.7rem;
  color: #a7f3d0;
  font-size: 8px;
  font-weight: 700;
  transform: translateX(-50%);
}

.live-label i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #34d399;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.55rem;
  margin-top: 0.7rem;
}

.metric-grid > div {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  padding: 0.65rem;
}

.metric-grid span,
.metric-grid strong,
.metric-grid small {
  display: block;
}

.metric-grid span {
  color: #94a3b8;
  font-size: 7px;
}

.metric-grid strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 13px;
}

.metric-grid small {
  margin-top: 2px;
  color: #64748b;
  font-size: 7px;
}

.metric-grid strong.metric-danger {
  color: #e11d48;
}

.attack-panel {
  border-color: #fecdd3;
}

.attack-panel.policy-open {
  background: linear-gradient(180deg, white, #fff7f8);
}

.attack-header {
  align-items: center;
}

.policy-switch {
  display: flex;
  min-width: 178px;
  align-items: center;
  gap: 0.55rem;
  border: 1px solid;
  border-radius: 11px;
  padding: 0.5rem 0.65rem;
  text-align: left;
}

.policy-switch:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.switch-dot {
  width: 28px;
  height: 16px;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.22;
}

.policy-switch strong,
.policy-switch small {
  display: block;
}

.policy-switch strong {
  font-size: 8px;
}

.policy-switch small {
  margin-top: 2px;
  font-size: 7px;
  opacity: 0.7;
}

.policy-safe {
  border-color: #6ee7b7;
  background: #ecfdf5;
  color: #047857;
}

.policy-risk {
  border-color: #fda4af;
  background: #fff1f2;
  color: #be123c;
}

.plain-guide {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin-top: 0.8rem;
  border-radius: 9px;
  background: #f8fafc;
  padding: 0.6rem 0.75rem;
  color: #64748b;
  font-size: 9px;
  line-height: 1.55;
}

.plain-guide strong {
  flex-shrink: 0;
  color: #0f172a;
  font-size: 9px;
}

.plain-guide span {
  color: #64748b;
}

.network-stage {
  position: relative;
  height: 235px;
  margin-top: 0.7rem;
  overflow: hidden;
  border: 1px solid #334155;
  border-radius: 14px;
  background: linear-gradient(rgba(148, 163, 184, 0.055) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.055) 1px, transparent 1px), #0f172a;
  background-size: 24px 24px;
}

.network-line {
  position: absolute;
  top: 49%;
  right: 10%;
  left: 10%;
  height: 1px;
  background: #475569;
}

.network-node {
  position: absolute;
  z-index: 7;
  top: 49%;
  display: grid;
  width: 92px;
  min-height: 96px;
  align-content: center;
  justify-items: center;
  border: 1px solid #475569;
  border-radius: 12px;
  background: #1e293b;
  transform: translate(-50%, -50%);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
}

.network-node strong {
  margin-top: 5px;
  color: #e2e8f0;
  font-size: 9px;
}

.network-node small {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 7px;
}

.source-node {
  left: 11%;
  border-color: rgba(251, 113, 133, 0.45);
}

.firewall-node {
  left: 50%;
  border-color: rgba(52, 211, 153, 0.55);
  color: #6ee7b7;
  box-shadow: 0 0 24px rgba(16, 185, 129, 0.12);
}

.firewall-node.open {
  border-color: rgba(251, 113, 133, 0.55);
  color: #fda4af;
  box-shadow: 0 0 24px rgba(244, 63, 94, 0.12);
}

.target-node {
  left: 89%;
  border-color: rgba(96, 165, 250, 0.45);
}

.target-node.hit {
  border-color: rgba(244, 114, 182, 0.6);
  animation: node-shake 0.35s ease-in-out infinite alternate;
}

.node-mark {
  display: flex;
  width: 35px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #334155;
  color: #cbd5e1;
  font-size: 7px;
  font-weight: 800;
}

.node-shield {
  display: flex;
  width: 35px;
  height: 35px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: rgba(16, 185, 129, 0.1);
}

.open .node-shield {
  background: rgba(244, 63, 94, 0.1);
}

.network-packet {
  position: absolute;
  z-index: 12;
  left: 11%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  opacity: 0;
  transform: translate(-50%, -50%);
}

.packet-allowed {
  background: #22c55e;
  box-shadow: 0 0 10px #22c55e;
  animation: packet-pass 2.35s linear both;
}

.packet-blocked {
  background: #f43f5e;
  box-shadow: 0 0 12px #f43f5e;
  animation: packet-stop 2.15s ease-out both;
}

.packet-leaked {
  background: #d946ef;
  box-shadow: 0 0 13px #d946ef;
  animation: packet-leak 2.35s linear both;
}

.network-legend {
  position: absolute;
  right: 10px;
  bottom: 8px;
  left: 10px;
  display: flex;
  justify-content: center;
  gap: 1rem;
  color: #94a3b8;
  font-size: 7px;
}

.network-legend span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.network-legend i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.legend-green {
  background: #22c55e;
}

.legend-red {
  background: #f43f5e;
}

.legend-purple {
  background: #d946ef;
}

.attack-button {
  display: flex;
  width: 100%;
  min-height: 54px;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  margin-top: 0.7rem;
  background: #be123c;
  color: white;
  box-shadow: 0 7px 17px rgba(190, 18, 60, 0.17);
}

.attack-button > span {
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.14);
  padding: 0.35rem 0.5rem;
  font-size: 8px;
}

.attack-button strong,
.attack-button small {
  display: block;
  text-align: left;
}

.attack-button strong {
  font-size: 10px;
}

.attack-button small {
  margin-top: 2px;
  font-size: 7px;
  opacity: 0.74;
}

.result-panel {
  margin-top: 0.7rem;
  border: 1px solid;
  border-radius: 11px;
  padding: 0.75rem 0.9rem;
}

.result-panel strong {
  font-size: 10px;
}

.result-panel p {
  margin-top: 3px;
  font-size: 8px;
  line-height: 1.5;
}

.neutral-result {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #475569;
}

.safe-result {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.risk-result {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.result-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.55rem;
  margin-top: 0.65rem;
}

.result-metrics > div {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #f8fafc;
  padding: 0.55rem 0.7rem;
}

.result-metrics span {
  color: #64748b;
  font-size: 7px;
}

.result-metrics strong {
  margin-left: auto;
  color: #0f172a;
  font-size: 13px;
}

.result-metrics small {
  color: #94a3b8;
  font-size: 7px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.section-icon {
  display: flex;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.warning-icon {
  background: #fffbeb;
  color: #d97706;
}

.log-icon {
  background: #eff6ff;
  color: #2563eb;
}

.section-title h2 {
  color: #0f172a;
  font-size: 12px;
  font-weight: 750;
}

.section-title p {
  margin-top: 2px;
  color: #64748b;
  font-size: 8px;
}

.empty-state {
  min-height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 0.8rem;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #f8fafc;
  text-align: center;
}

.empty-state strong {
  color: #475569;
  font-size: 9px;
}

.empty-state p {
  margin-top: 4px;
  color: #94a3b8;
  font-size: 7px;
}

.finding-list {
  display: grid;
  gap: 0.55rem;
  margin-top: 0.8rem;
}

.finding-item {
  border: 1px solid #fed7aa;
  border-radius: 11px;
  background: #fff7ed;
  padding: 0.7rem;
}

.finding-item > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.finding-item strong {
  color: #9a3412;
  font-size: 9px;
}

.finding-item span {
  border: 1px solid;
  border-radius: 999px;
  padding: 2px 5px;
  font-size: 7px;
  font-weight: 700;
}

.finding-item p {
  margin-top: 5px;
  color: #c2410c;
  font-size: 8px;
}

.finding-buttons {
  display: flex;
  gap: 0.4rem;
  margin-top: 0.55rem;
}

.finding-buttons button {
  min-height: 31px;
  flex: 1;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 700;
}

.block-action {
  background: #e11d48;
  color: white;
}

.ignore-action {
  border: 1px solid #fed7aa;
  background: white;
  color: #9a3412;
}

.finding-status {
  margin-top: 0.55rem;
  border-radius: 8px;
  background: white;
  padding: 0.4rem;
  color: #9a3412;
  font-size: 8px;
  text-align: center;
}

.active-blocks {
  display: grid;
  gap: 0.4rem;
  margin-top: 0.7rem;
}

.active-blocks > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 9px;
  background: #fff1f2;
  padding: 0.5rem 0.65rem;
  color: #be123c;
  font-size: 8px;
}

.active-blocks button {
  color: #64748b;
  text-decoration: underline;
}

.event-list {
  display: grid;
  gap: 0.4rem;
  max-height: 330px;
  margin-top: 0.8rem;
  overflow-y: auto;
  scrollbar-width: thin;
}

.event-row {
  display: grid;
  grid-template-columns: 72px 115px 58px 1fr;
  align-items: center;
  gap: 0.45rem;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #f8fafc;
  padding: 0.5rem 0.6rem;
  font-size: 8px;
}

.event-time {
  color: #94a3b8;
}

.event-source {
  overflow: hidden;
  color: #334155;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.event-action {
  border: 1px solid;
  border-radius: 999px;
  padding: 2px 4px;
  font-size: 7px;
  font-weight: 700;
  text-align: center;
}

.event-row p {
  overflow: hidden;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.technical-panel {
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  background: white;
}

.technical-panel summary {
  display: flex;
  min-height: 62px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1rem;
  list-style: none;
}

.technical-panel summary::-webkit-details-marker {
  display: none;
}

.technical-panel summary strong,
.technical-panel summary small {
  display: block;
}

.technical-panel summary strong {
  color: #334155;
  font-size: 10px;
}

.technical-panel summary small {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 8px;
}

.technical-panel summary > span {
  color: #64748b;
  font-size: 8px;
}

.technical-content {
  border-top: 1px solid #e2e8f0;
  padding: 1rem;
}

.project-title {
  border-radius: 9px;
  background: #eff6ff;
  padding: 0.65rem 0.8rem;
  color: #1e3a8a;
  font-size: 9px;
  font-weight: 700;
}

.technical-table {
  width: 100%;
  min-width: 680px;
  margin-top: 0.7rem;
  border-collapse: collapse;
  font-size: 8px;
  text-align: left;
}

.technical-table th,
.technical-table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 0.5rem;
}

.technical-table th {
  color: #64748b;
  font-weight: 700;
}

.technical-table td {
  color: #334155;
}

.technical-settings {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.45rem;
  margin-top: 0.7rem;
}

.technical-settings > div {
  border-radius: 9px;
  background: #f8fafc;
  padding: 0.6rem;
}

.technical-settings span,
.technical-settings strong {
  display: block;
}

.technical-settings span {
  color: #94a3b8;
  font-size: 7px;
}

.technical-settings strong {
  margin-top: 3px;
  color: #334155;
  font-size: 9px;
}

.product-footer {
  padding: 0.5rem 0 1.5rem;
  color: #94a3b8;
  font-size: 8px;
  line-height: 1.7;
  text-align: center;
}

@keyframes hero-packet {
  0% {
    left: 0;
    opacity: 0;
  }
  15%, 85% {
    opacity: 1;
  }
  100% {
    left: calc(100% - 5px);
    opacity: 0;
  }
}
@keyframes user-enter {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes subtle-pulse {
  from {
    transform: scale(0.97);
  }
  to {
    transform: scale(1.04);
  }
}
@keyframes node-shake {
  from {
    transform: translate(-50%, -50%) translateX(-1px);
  }
  to {
    transform: translate(-50%, -50%) translateX(1px);
  }
}
@keyframes packet-pass {
  0% {
    left: 11%;
    opacity: 0;
  }
  10%, 90% {
    opacity: 1;
  }
  100% {
    left: 89%;
    opacity: 0;
  }
}
@keyframes packet-stop {
  0% {
    left: 11%;
    opacity: 0;
  }
  12%, 68% {
    opacity: 1;
  }
  76% {
    left: 47%;
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    left: 49%;
    opacity: 0;
    transform: translate(-50%, -50%) scale(3.4);
  }
}
@keyframes packet-leak {
  0% {
    left: 11%;
    opacity: 0;
  }
  10%, 90% {
    opacity: 1;
  }
  54% {
    left: 52%;
  }
  100% {
    left: 89%;
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.7);
  }
}
@media (max-width: 820px) {
  .intro-panel {
    min-height: 0;
    padding: 1.4rem;
  }
  .hero-network {
    display: none;
  }
  .command-center {
    grid-template-columns: 1fr;
  }
  .security-check-grid {
    grid-column: 1;
    grid-template-columns: repeat(2, 1fr);
  }
  .policy-layout {
    grid-template-columns: 1fr;
  }
  .progress-panel {
    justify-content: flex-start;
    overflow-x: auto;
  }
  .progress-step {
    min-width: 110px;
  }
  .progress-line {
    min-width: 25px;
  }
  .attack-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .policy-switch {
    width: 100%;
  }
  .technical-settings {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 560px) {
  .safe-badge {
    display: none;
  }
  .panel {
    padding: 1rem;
  }
  .command-primary {
    grid-template-columns: auto 1fr;
  }
  .command-button {
    grid-column: 1/-1;
    width: 100%;
  }
  .security-check-grid {
    grid-template-columns: 1fr;
  }
  .policy-input-grid,
  .policy-safeguards {
    grid-template-columns: 1fr;
  }
  .rule-card {
    grid-template-columns: 26px 1fr;
  }
  .rule-action {
    grid-column: 2;
    width: max-content;
  }
  .user-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .arena {
    height: 300px;
  }
  .metric-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .network-stage {
    height: 210px;
  }
  .network-node {
    width: 76px;
    min-height: 84px;
  }
  .network-node strong {
    font-size: 8px;
  }
  .network-node small {
    max-width: 64px;
    text-align: center;
  }
  .event-row {
    grid-template-columns: 65px 1fr 50px;
  }
  .event-row p {
    grid-column: 1/-1;
    white-space: normal;
  }
}
@media (prefers-reduced-motion: reduce) {
  .user-card,
  .arena-user > span,
  .target-node.hit,
  .network-packet {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
  .arena-user {
    transition: none;
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public config: any = null;
    public loading: boolean = true;
    public loadError: string = '';

    public serverRunning: boolean = false;
    public gameRunning: boolean = false;
    public protectionEnabled: boolean = true;
    public agentStatus: string = 'STANDBY';
    public rules: any[] = [];
    public events: any[] = [];
    public detections: any[] = [];
    public blocks: any[] = [];
    public players: any[] = [];
    public networkPackets: any[] = [];
    public friendsJoining: boolean = false;
    public joinNotice: string = '';

    public firewallDraft: any = {
        gamePort: 7777,
        protocol: 'UDP',
        adminPort: 27020,
        adminIp: '203.0.113.10/32'
    };
    public firewallBuilt: boolean = false;
    public firewallApplied: boolean = false;
    public firewallErrors: string[] = [];

    public totalConnections: number = 0;
    public allowedPackets: number = 0;
    public blockedPackets: number = 0;
    public leakedPackets: number = 0;
    public attackWaves: number = 0;
    public serverHealth: number = 100;
    public latency: number = 22;
    public tickRate: number = 60;
    public simulationMessage: string = '1단계에서 게임 서버용 방화벽 규칙을 먼저 만드세요.';

    private timer: any = null;
    private packetTimers: any[] = [];
    private movementStep: number = 0;
    private packetSequence: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadConfig();
        this.timer = window.setInterval(async () => {
            await this.tick();
        }, 1000);
    }

    public ngOnDestroy() {
        if (this.timer) window.clearInterval(this.timer);
        this.packetTimers.forEach((timer: any) => window.clearTimeout(timer));
    }

    public async loadConfig() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();

        const { code, data } = await wiz.call("config");
        if (code !== 200 || !data || !data.config) {
            this.loadError = data?.message || 'config.yaml을 불러오지 못했습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }

        this.config = data.config;
        this.initializeFirewallDraft();
        this.rules = [];
        this.seedEvents();
        this.loading = false;
        await this.service.render();
    }

    public initializeFirewallDraft() {
        const game = this.config?.ports?.game?.[0] || {};
        const admin = this.config?.ports?.admin?.[0] || {};
        this.firewallDraft = {
            gamePort: game.port || 7777,
            protocol: (game.protocol || 'UDP').toUpperCase(),
            adminPort: admin.port || 27020,
            adminIp: this.config?.admin_allowlist?.[0] || '203.0.113.10/32'
        };
    }

    public async updateFirewallField(field: string, event: Event) {
        if (this.serverRunning) return;
        const target = event.target as HTMLInputElement;
        this.firewallDraft[field] = target.value;
        this.firewallBuilt = false;
        this.firewallApplied = false;
        this.firewallErrors = [];
        this.rules = [];
        this.simulationMessage = '설정이 바뀌었습니다. 방화벽 정책을 다시 만들어주세요.';
        await this.service.render();
    }

    public async buildFirewallPolicy() {
        if (this.serverRunning) {
            await this.service.modal.warning('서버를 종료한 뒤 방화벽 설정을 변경할 수 있습니다.', false, '확인');
            return;
        }

        const gamePort = this.parsePort(this.firewallDraft.gamePort);
        const adminPort = this.parsePort(this.firewallDraft.adminPort);
        const protocol = String(this.firewallDraft.protocol || '').toUpperCase();
        const adminIp = String(this.firewallDraft.adminIp || '').trim();
        const errors: string[] = [];

        if (gamePort === null) errors.push('게임 포트는 1~65535 사이의 숫자여야 합니다.');
        if (adminPort === null) errors.push('관리 포트는 1~65535 사이의 숫자여야 합니다.');
        if (gamePort !== null && adminPort !== null && gamePort === adminPort) {
            errors.push('게임 포트와 관리 포트는 서로 달라야 합니다.');
        }
        if (!['TCP', 'UDP'].includes(protocol)) errors.push('연결 방식은 TCP 또는 UDP만 선택할 수 있습니다.');
        if (!this.isValidIpv4Cidr(adminIp)) errors.push('관리자 IP는 203.0.113.10 또는 203.0.113.10/32 형식이어야 합니다.');

        this.firewallErrors = errors;
        if (errors.length || gamePort === null || adminPort === null) {
            this.firewallBuilt = false;
            this.firewallApplied = false;
            this.rules = [];
            this.simulationMessage = '입력값을 확인한 뒤 방화벽 정책을 다시 만들어주세요.';
            await this.service.render();
            return;
        }

        this.firewallDraft = { gamePort, protocol, adminPort, adminIp };
        const prefix = this.config.agent.rule_prefix;
        this.rules = [
            {
                id: prefix + '-GAME-' + protocol + '-' + gamePort,
                category: 'GAME',
                label: '게임 접속 허용',
                source: '0.0.0.0/0',
                port: gamePort,
                protocol,
                action: 'ALLOW',
                active: false
            },
            {
                id: prefix + '-ADMIN-TCP-' + adminPort,
                category: 'ADMIN',
                label: '관리자 접속 제한',
                source: adminIp,
                port: adminPort,
                protocol: 'TCP',
                action: 'ALLOW',
                active: false
            },
            {
                id: prefix + '-DEFAULT-DENY',
                category: 'DEFAULT',
                label: '그 외 접속 차단',
                source: '0.0.0.0/0',
                port: 'ALL',
                protocol: '*',
                action: 'DENY',
                active: false
            }
        ];
        this.firewallBuilt = true;
        this.firewallApplied = false;
        this.simulationMessage = '방화벽 정책이 준비되었습니다. 서버를 열면 이 규칙만 예시 적용됩니다.';
        this.addEvent('보안 에이전트', gamePort, protocol, 'SAFE', '게임 포트 허용 규칙을 만들었습니다');
        this.addEvent('보안 에이전트', adminPort, 'TCP', 'SAFE', '관리 포트를 관리자 IP로 제한했습니다');
        this.addEvent('보안 에이전트', '그 외 포트', '*', 'DENY', '등록하지 않은 연결은 기본 차단합니다');
        await this.service.render();
    }

    private parsePort(value: any): number | null {
        const parsed = Number(value);
        if (!Number.isInteger(parsed) || parsed < 1 || parsed > 65535) return null;
        return parsed;
    }

    private isValidIpv4Cidr(value: string): boolean {
        const parts = value.split('/');
        if (parts.length > 2 || !parts[0]) return false;
        if (parts.length === 2) {
            const prefix = Number(parts[1]);
            if (!Number.isInteger(prefix) || prefix < 0 || prefix > 32) return false;
        }

        const octets = parts[0].split('.');
        return octets.length === 4 && octets.every((item: string) => {
            if (!/^\d{1,3}$/.test(item)) return false;
            const value = Number(item);
            return value >= 0 && value <= 255;
        });
    }

    public seedEvents() {
        this.events = [
            this.makeEvent('보안 에이전트', '-', '-', 'INFO', '방화벽 정책 설계 화면이 준비되었습니다'),
            this.makeEvent('보안 에이전트', '-', '-', 'SAFE', '실제 운영체제 방화벽은 변경하지 않습니다'),
            this.makeEvent('보안 에이전트', '-', '-', 'INFO', '의심 접근은 관리자 확인 후 차단합니다')
        ];
    }

    public makeEvent(ip: string, port: any, protocol: string, action: string, reason: string) {
        return {
            id: Date.now().toString() + '-' + Math.random().toString(16).slice(2),
            time: new Date().toLocaleTimeString('ko-KR', { hour12: false }),
            ip: ip,
            port: port,
            protocol: protocol,
            action: action,
            reason: reason
        };
    }

    public addEvent(ip: string, port: any, protocol: string, action: string, reason: string) {
        this.events.unshift(this.makeEvent(ip, port, protocol, action, reason));
        this.events = this.events.slice(0, 60);
    }

    public get completedStepCount() {
        return [
            this.firewallBuilt,
            this.serverRunning,
            this.players.length >= 6,
            this.gameRunning,
            this.attackWaves > 0
        ].filter(Boolean).length;
    }

    public get currentStepNumber() {
        if (!this.firewallBuilt) return 1;
        if (!this.serverRunning) return 2;
        if (this.players.length < 6) return 3;
        if (!this.gameRunning) return 4;
        return 5;
    }

    public get nextActionTitle() {
        if (!this.firewallBuilt) return '방화벽 정책을 먼저 만드세요';
        if (!this.serverRunning) return '준비한 규칙을 서버에 적용하세요';
        if (this.friendsJoining) return '친구들이 접속하고 있습니다';
        if (this.players.length < 6) return '정상 사용자 접속을 확인하세요';
        if (!this.gameRunning) return '6명이 연결된 게임을 시작하세요';
        if (this.attackWaves === 0) return '공격을 보내 방화벽을 검증하세요';
        return '같은 조건으로 다시 검증할 수 있습니다';
    }

    public get nextActionDescription() {
        if (!this.firewallBuilt) {
            return '게임 포트와 관리자 IP를 확인하면 허용 2개와 기본 차단 1개 규칙이 만들어집니다.';
        }
        if (!this.serverRunning) {
            return '서버를 열 때 ' + this.rules.length + '개 규칙을 함께 활성화하고, 서버 종료 시 자동으로 해제합니다.';
        }
        if (this.players.length < 6) {
            return '허용한 ' + this.firewallDraft.gamePort + '/' + this.firewallDraft.protocol + ' 경로로 친구 5명이 접속합니다.';
        }
        if (!this.gameRunning) {
            return '정상 사용자 6명의 연결을 유지한 상태로 보안 시험을 준비합니다.';
        }
        return '정상 사용자는 유지되고 반복 접속·포트 탐색·관리자 접근만 차단되는지 확인합니다.';
    }

    public get nextActionButtonLabel() {
        if (!this.firewallBuilt) return '정책 만들기';
        if (!this.serverRunning) return '서버 열기';
        if (this.friendsJoining) return '친구 접속 중';
        if (this.players.length < 6) return '친구 접속';
        if (!this.gameRunning) return '게임 시작';
        if (this.attackWaves === 0) return '방화벽 검증';
        return '공격 다시 실행';
    }

    public get nextActionDisabled() {
        return this.friendsJoining || this.agentStatus === 'APPLYING' || this.agentStatus === 'ROLLING BACK';
    }

    public async runNextStep() {
        if (this.nextActionDisabled) return;
        if (!this.firewallBuilt) {
            await this.buildFirewallPolicy();
            return;
        }
        if (!this.serverRunning) {
            await this.startServer();
            return;
        }
        if (this.players.length < 6) {
            await this.inviteFriends();
            return;
        }
        if (!this.gameRunning) {
            await this.toggleGame();
            return;
        }
        await this.launchAttackWave();
    }

    public async toggleServer() {
        if (this.serverRunning) {
            await this.stopServer();
        } else {
            await this.startServer();
        }
    }

    public async startServer() {
        if (!this.firewallBuilt) {
            await this.service.modal.warning('1단계에서 방화벽 정책을 먼저 만들어주세요.', false, '확인');
            return;
        }

        this.agentStatus = 'APPLYING';
        this.simulationMessage = '게임 서버를 시작하고 방화벽 규칙을 준비하고 있습니다.';
        this.addEvent('게임방', '-', '-', 'INFO', '게임 서버 시작 중');
        await this.service.render();
        await this.service.sleep(450);

        this.serverRunning = true;
        this.serverHealth = 100;
        this.latency = 22;
        this.tickRate = 60;
        this.agentStatus = 'MONITORING';
        this.firewallApplied = true;
        this.rules.forEach((rule: any) => rule.active = true);
        this.players = [
            { id: 'ME', name: '나', role: '방장', team: 'cyan', x: 18, y: 48, hp: 100 }
        ];
        this.allowedPackets += 1;
        this.totalConnections += 1;
        this.joinNotice = '관리자 사용자가 접속했습니다.';
        this.simulationMessage = '게임 서버가 실행 중입니다. 다음 단계에서 친구 접속을 시뮬레이션하세요.';
        this.addEvent('나(방장)', this.firewallDraft.gamePort, this.firewallDraft.protocol, 'ALLOW', '게임 서버에 정상 접속');
        this.addEvent('보안 에이전트', this.firewallDraft.gamePort, this.firewallDraft.protocol, 'SAFE', '설계한 게임 포트 규칙을 예시 적용했습니다');
        this.addEvent('보안 에이전트', this.firewallDraft.adminPort, 'TCP', 'SAFE', '관리 포트는 등록한 관리자 IP만 허용합니다');
        this.emitPackets('allowed', 48, 1);
        await this.service.render();
    }

    public async stopServer() {
        this.agentStatus = 'ROLLING BACK';
        this.gameRunning = false;
        this.friendsJoining = false;
        this.players = [];
        this.joinNotice = '';
        this.simulationMessage = '사용자 연결을 종료하고 관리 규칙을 정리하고 있습니다.';
        this.addEvent('게임방', '-', '-', 'WARN', '게임 서버 종료 시작');
        await this.service.render();
        await this.service.sleep(450);

        this.serverRunning = false;
        this.firewallApplied = false;
        this.protectionEnabled = true;
        this.agentStatus = 'STANDBY';
        this.rules.forEach((rule: any) => rule.active = false);
        this.networkPackets = [];
        this.simulationMessage = '게임 서버가 종료되었습니다. 다른 프로그램의 방화벽 규칙은 유지됩니다.';
        this.addEvent('보안 에이전트', '관리 규칙', '*', 'CLOSE', '에이전트가 생성한 규칙만 제거했습니다');
        await this.service.render();
    }

    public async inviteFriends() {
        if (!this.serverRunning) {
            await this.service.modal.warning('2단계에서 게임 서버를 먼저 열어주세요.', false, '확인');
            return;
        }
        if (this.friendsJoining || this.players.length >= 6) return;

        const friends = [
            { id: 'F1', name: '민준', role: '친구', team: 'cyan', x: 28, y: 67, hp: 100 },
            { id: 'F2', name: '서연', role: '친구', team: 'cyan', x: 39, y: 30, hp: 100 },
            { id: 'F3', name: '지우', role: '친구', team: 'rose', x: 63, y: 30, hp: 100 },
            { id: 'F4', name: '유나', role: '친구', team: 'rose', x: 76, y: 67, hp: 100 },
            { id: 'F5', name: '하준', role: '친구', team: 'rose', x: 58, y: 56, hp: 100 }
        ];
        const joinedIds = new Set(this.players.map((player: any) => player.id));
        this.friendsJoining = true;
        this.simulationMessage = '친구 접속을 시작합니다. 사용자가 한 명씩 연결됩니다.';
        await this.service.render();

        for (const friend of friends) {
            if (joinedIds.has(friend.id)) continue;
            await this.service.sleep(430);
            if (!this.serverRunning) {
                this.friendsJoining = false;
                return;
            }
            this.players.push(friend);
            this.allowedPackets += 1;
            this.totalConnections += 1;
            this.joinNotice = friend.name + ' 사용자가 접속했습니다.';
            this.addEvent(friend.name, this.firewallDraft.gamePort, this.firewallDraft.protocol, 'ALLOW', '초대받은 친구가 게임 서버에 정상 접속');
            this.emitPackets('allowed', 48, 1);
            await this.service.render();
        }

        this.friendsJoining = false;
        this.joinNotice = '친구 5명의 접속이 완료되었습니다.';
        this.simulationMessage = '모든 사용자가 접속했습니다. 다음 단계에서 게임을 시작하세요.';
        await this.service.render();
    }

    public async toggleGame() {
        if (!this.serverRunning) {
            await this.service.modal.warning('2단계에서 게임 서버를 먼저 열어주세요.', false, '확인');
            return;
        }
        if (this.players.length < 6 || this.friendsJoining) {
            await this.service.modal.warning('3단계에서 친구 5명의 접속이 완료될 때까지 기다려주세요.', false, '확인');
            return;
        }

        this.gameRunning = !this.gameRunning;
        if (this.gameRunning) {
            this.joinNotice = '게임 플레이가 시작되었습니다.';
            this.simulationMessage = '정상 사용자 6명이 플레이 중입니다. 다음 단계에서 공격을 시뮬레이션하세요.';
            this.addEvent('친구 6명', this.firewallDraft.gamePort, this.firewallDraft.protocol, 'ALLOW', '정상 사용자 6명이 게임을 시작했습니다');
        } else {
            this.joinNotice = '게임이 일시정지되었습니다.';
            this.simulationMessage = '게임이 일시정지되었으며 사용자 연결은 유지됩니다.';
            this.addEvent('친구 6명', this.firewallDraft.gamePort, this.firewallDraft.protocol, 'INFO', '게임 일시정지 · 사용자 연결 유지');
        }
        await this.service.render();
    }

    public async setProtection(enabled: boolean) {
        if (!this.serverRunning) {
            await this.service.modal.warning('2단계에서 방화벽을 적용하고 서버를 먼저 열어주세요.', false, '확인');
            return;
        }
        if (this.protectionEnabled === enabled) return;
        this.protectionEnabled = enabled;
        if (enabled) {
            this.simulationMessage = '방화벽 보호를 활성화했습니다. 정상 연결은 유지되고 의심 접근은 차단됩니다.';
            this.addEvent('보안 에이전트', '전체 포트', '*', 'SAFE', '허용된 게임·관리 포트 외 접근을 차단합니다');
        } else {
            this.simulationMessage = '취약 설정 비교 모드입니다. 실제 운영체제 방화벽은 변경되지 않습니다.';
            this.addEvent('보안 에이전트', '전체 포트', '*', 'WARN', '시뮬레이션에서만 방화벽 정책이 완화됩니다');
        }
        await this.service.render();
    }

    public async launchAttackWave() {
        if (!this.serverRunning || !this.gameRunning) {
            await this.service.modal.warning('1단계부터 4단계까지 진행해 게임 플레이를 먼저 시작하세요.', false, '확인');
            return;
        }

        this.attackWaves += 1;
        this.simulationMessage = this.protectionEnabled
            ? '의심 접근이 감지되었습니다. 공격 패킷이 방화벽에서 차단되는지 확인하세요.'
            : '취약 설정으로 인해 공격 패킷이 게임 서버에 도달했습니다.';
        this.addEvent('의심 접속', '여러 포트', '*', 'WARN', '반복 접속, 포트 탐색, 관리자 접근이 동시에 발생했습니다');
        await this.runScenario('repeat');
        await this.runScenario('scan');
        await this.runScenario('admin');
        await this.service.render();
    }

    public async runScenario(type: string) {
        if (!this.serverRunning) {
            await this.service.modal.warning('2단계에서 게임 서버를 먼저 열어주세요.', false, '확인');
            return;
        }

        if (type === 'normal') {
            for (let index = 0; index < 3; index++) {
                this.addEvent('신규 사용자', this.firewallDraft.gamePort, this.firewallDraft.protocol, 'ALLOW', '친구가 허용한 게임 포트로 정상 접속했습니다');
            }
            this.totalConnections += 3;
            this.allowedPackets += 3;
            this.emitPackets('allowed', 48, 3);
            this.simulationMessage = '정상 사용자의 게임 연결이 허용되었습니다.';
        }

        if (type === 'repeat') {
            const count = this.config.detection.max_connections_per_ip + 3;
            this.totalConnections += count;
            this.addDetection(
                '198.51.100.24',
                'HIGH',
                '동일 사용자의 연결 시도가 기준을 초과했습니다',
                count,
                [this.firewallDraft.gamePort]
            );
            this.applyThreatImpact('의심 접속 1', this.firewallDraft.gamePort, this.firewallDraft.protocol, count, 25, '과도한 반복 접속');
        }

        if (type === 'scan') {
            const ports = [21, 22, 80, 443, 3389];
            this.totalConnections += ports.length;
            this.addDetection(
                '198.51.100.77',
                'CRITICAL',
                '여러 포트를 짧은 시간에 탐색했습니다',
                ports.length,
                ports
            );
            this.applyThreatImpact('의심 접속 2', '여러 포트', 'TCP', ports.length, 50, '여러 포트 찾아보기');
        }

        if (type === 'admin') {
            const count = 3;
            this.totalConnections += count;
            this.addDetection(
                '198.51.100.90',
                'MEDIUM',
                '등록되지 않은 IP가 관리 포트에 접근했습니다',
                count,
                [this.firewallDraft.adminPort]
            );
            this.applyThreatImpact('의심 접속 3', this.firewallDraft.adminPort, 'TCP', count, 75, '비인가 관리 포트 접근');
        }

        await this.service.render();
    }

    private applyThreatImpact(ip: string, port: any, protocol: string, count: number, lane: number, reason: string) {
        if (this.protectionEnabled) {
            this.blockedPackets += count;
            this.emitPackets('blocked', lane, Math.min(count, 5));
            this.addEvent(ip, port, protocol, 'DENY', reason + ' · 방화벽이 차단했습니다');
            this.latency = Math.min(38, this.latency + 2);
            return;
        }

        this.leakedPackets += count;
        this.emitPackets('leaked', lane, Math.min(count, 5));
        this.serverHealth = Math.max(8, this.serverHealth - Math.ceil(count * 1.4));
        this.latency = Math.min(220, this.latency + count * 2);
        this.tickRate = Math.max(18, this.tickRate - Math.ceil(count / 2));
        this.addEvent(ip, port, protocol, 'BYPASS', reason + ' · 취약한 정책을 통과했습니다');
    }

    private emitPackets(kind: string, top: number, count: number) {
        const ids: number[] = [];
        for (let index = 0; index < count; index++) {
            this.packetSequence += 1;
            ids.push(this.packetSequence);
            this.networkPackets.push({
                id: this.packetSequence,
                kind: kind,
                top: Math.max(12, Math.min(88, top + (index - 2) * 4)),
                delay: index * 130
            });
        }

        const timer = window.setTimeout(async () => {
            this.networkPackets = this.networkPackets.filter((packet: any) => !ids.includes(packet.id));
            await this.service.render();
        }, 3300);
        this.packetTimers.push(timer);
    }

    public addDetection(ip: string, severity: string, reason: string, count: number, ports: number[]) {
        const existing = this.detections.find((item: any) => item.ip === ip && item.status === 'pending');
        if (existing) {
            existing.count += count;
            existing.ports = Array.from(new Set(existing.ports.concat(ports)));
            return;
        }

        this.detections.unshift({
            id: Date.now().toString() + '-' + ip,
            ip: ip,
            severity: severity,
            reason: reason,
            count: count,
            ports: ports,
            duration: this.config.detection.temporary_ban_sec,
            status: 'pending'
        });
    }

    public async approve(item: any) {
        item.status = 'active';
        item.expiresAt = Date.now() + item.duration * 1000;
        item.remaining = item.duration;
        this.blocks.push({
            id: this.config.agent.rule_prefix + '-BLOCK-' + item.ip.replace(/\./g, '-'),
            ip: item.ip,
            reason: item.reason,
            expiresAt: item.expiresAt,
            remaining: item.duration
        });
        this.addEvent(item.ip, 'ALL', '*', 'BLOCK', '관리자 승인 · ' + item.duration + '초 임시 차단');
        await this.service.render();
    }

    public async ignore(item: any) {
        item.status = 'ignored';
        this.addEvent(item.ip, 'ALL', '*', 'IGNORE', '관리자가 차단 제안을 무시함');
        await this.service.render();
    }

    public async unblock(block: any) {
        this.blocks = this.blocks.filter((item: any) => item.id !== block.id);
        const finding = this.detections.find((item: any) => item.ip === block.ip && item.status === 'active');
        if (finding) finding.status = 'released';
        this.addEvent(block.ip, 'ALL', '*', 'UNBLOCK', '관리자 수동 해제');
        await this.service.render();
    }

    public async tick() {
        let changed = false;

        if (this.gameRunning && this.players.length) {
            this.movementStep += 1;
            this.players = this.players.map((player: any, index: number) => {
                const horizontal = ((this.movementStep + index) % 3) - 1;
                const vertical = ((this.movementStep + index * 2) % 3) - 1;
                return {
                    ...player,
                    x: Math.max(8, Math.min(92, player.x + horizontal * 3)),
                    y: Math.max(12, Math.min(82, player.y + vertical * 2))
                };
            });
            if (this.protectionEnabled) {
                this.serverHealth = Math.min(100, this.serverHealth + 1);
                this.latency = Math.max(22, this.latency - 2);
                this.tickRate = Math.min(60, this.tickRate + 1);
            }
            changed = true;
        }

        if (this.blocks.length) {
            const now = Date.now();
            const expired = this.blocks.filter((item: any) => item.expiresAt <= now);
            this.blocks.forEach((item: any) => {
                item.remaining = Math.max(0, Math.ceil((item.expiresAt - now) / 1000));
            });

            if (expired.length) {
                this.blocks = this.blocks.filter((item: any) => item.expiresAt > now);
                for (const block of expired) {
                    const finding = this.detections.find((item: any) => item.ip === block.ip && item.status === 'active');
                    if (finding) finding.status = 'expired';
                    this.addEvent(block.ip, 'ALL', '*', 'UNBLOCK', '임시 차단 시간 만료 · 자동 해제');
                }
            }
            changed = true;
        }

        if (changed) await this.service.render();
    }

    public async resetSimulation() {
        this.packetTimers.forEach((timer: any) => window.clearTimeout(timer));
        this.packetTimers = [];
        this.serverRunning = false;
        this.gameRunning = false;
        this.firewallBuilt = false;
        this.firewallApplied = false;
        this.firewallErrors = [];
        this.friendsJoining = false;
        this.joinNotice = '';
        this.protectionEnabled = true;
        this.agentStatus = 'STANDBY';
        this.totalConnections = 0;
        this.allowedPackets = 0;
        this.blockedPackets = 0;
        this.leakedPackets = 0;
        this.attackWaves = 0;
        this.serverHealth = 100;
        this.latency = 22;
        this.tickRate = 60;
        this.players = [];
        this.networkPackets = [];
        this.detections = [];
        this.blocks = [];
        this.simulationMessage = '1단계에서 게임 서버용 방화벽 규칙을 먼저 만드세요.';
        this.initializeFirewallDraft();
        this.rules = [];
        this.seedEvents();
        await this.service.render();
    }

    public displayRuleSource(rule: any) {
        if (rule.category === 'GAME') return '게임 포트 접속자';
        if (rule.category === 'DEFAULT') return '등록되지 않은 모든 접속';
        if (!this.protectionEnabled) return '관리자 IP 제한 없음 (비교)';
        return rule.source;
    }

    public displayRuleCategory(rule: any) {
        if (rule.category === 'GAME') return '게임 허용';
        if (rule.category === 'ADMIN') return '관리자 제한';
        return '기본 차단';
    }

    public get securityChecks() {
        const gameRuleSafe = this.firewallApplied && this.rules
            .filter((rule: any) => rule.category === 'GAME')
            .every((rule: any) => rule.active);
        const defaultDenySafe = this.firewallApplied && this.rules
            .some((rule: any) => rule.category === 'DEFAULT' && rule.action === 'DENY' && rule.active);
        return [
            {
                label: '게임 포트만 허용',
                detail: gameRuleSafe ? this.firewallDraft.gamePort + '/' + this.firewallDraft.protocol + ' 규칙 적용' : '서버 시작 전 대기',
                pass: gameRuleSafe
            },
            {
                label: '관리 포트는 관리자만 허용',
                detail: this.protectionEnabled ? this.firewallDraft.adminIp + '만 접속 가능' : '관리자 IP 제한 없음 (비교)',
                pass: this.firewallApplied && this.protectionEnabled
            },
            {
                label: '그 외 포트는 기본 차단',
                detail: defaultDenySafe && this.protectionEnabled ? '등록하지 않은 연결 거부' : '기본 차단이 해제된 비교 상태',
                pass: defaultDenySafe && this.protectionEnabled
            },
            {
                label: '정상 접속과 공격을 구분',
                detail: this.attackWaves === 0
                    ? '공격 검증 전'
                    : this.leakedPackets === 0 ? '서버에 도달한 공격 0건' : '공격 ' + this.leakedPackets + '건이 서버에 도달',
                pass: this.firewallApplied && this.protectionEnabled && this.attackWaves > 0 && this.leakedPackets === 0
            }
        ];
    }

    public get securityScore() {
        return this.securityChecks.filter((item: any) => item.pass).length * 25;
    }

    public get securityGrade() {
        if (!this.firewallBuilt) return '설계 전';
        if (!this.serverRunning) return '적용 대기';
        if (this.securityScore >= 100) return '안전';
        if (this.securityScore >= 75) return '검증 대기';
        if (this.securityScore >= 50) return '주의';
        return '위험';
    }

    public get securityLabel() {
        if (!this.firewallBuilt) return '방화벽 정책을 먼저 만드세요';
        if (!this.serverRunning) return '정책 준비 완료 · 서버 시작 대기';
        if (this.securityScore >= 100) return '정상 접속은 허용하고 의심 접근은 차단합니다';
        if (this.securityScore >= 75 && this.attackWaves === 0) return '규칙 적용 완료 · 공격 검증이 남았습니다';
        if (this.securityScore >= 75) return '일부 설정을 다시 확인하세요';
        return '방화벽 설정을 수정해야 합니다';
    }

    public get agentLabel() {
        if (this.agentStatus === 'MONITORING') return '모니터링 중';
        if (this.agentStatus === 'APPLYING') return '규칙 적용 중';
        if (this.agentStatus === 'ROLLING BACK') return '규칙 정리 중';
        return '대기 중';
    }

    public displayVisitor(ip: string) {
        if (ip === '198.51.100.24') return '의심 접속 1';
        if (ip === '198.51.100.77') return '의심 접속 2';
        if (ip === '198.51.100.90') return '의심 접속 3';
        return ip;
    }

    public detectionStatusLabel(status: string) {
        if (status === 'pending') return '관리자 확인 대기';
        if (status === 'active') return '임시 차단 중';
        if (status === 'expired') return '차단 시간 만료';
        if (status === 'released') return '관리자 해제';
        return '차단하지 않음';
    }

    public actionLabel(action: string) {
        if (action === 'ALLOW') return '허용';
        if (action === 'DENY') return '거부';
        if (action === 'BLOCK') return '차단';
        if (action === 'BYPASS') return '통과';
        if (action === 'SAFE') return '안전';
        if (action === 'WARN') return '주의';
        if (action === 'CLOSE') return '종료';
        if (action === 'UNBLOCK') return '해제';
        if (action === 'IGNORE') return '무시';
        return '알림';
    }

    public severityLabel(severity: string) {
        if (severity === 'CRITICAL') return '매우 높음';
        if (severity === 'HIGH') return '높음';
        return '확인 필요';
    }

    public get activeRuleCount() {
        return this.rules.filter((rule: any) => rule.active).length + this.blocks.length;
    }

    public get pendingCount() {
        return this.detections.filter((item: any) => item.status === 'pending').length;
    }

    public get deniedCount() {
        return this.events.filter((item: any) => item.action === 'DENY' || item.action === 'BLOCK').length;
    }

    public actionClass(action: string) {
        if (action === 'ALLOW' || action === 'SAFE') return 'text-emerald-300 bg-emerald-400/10 border-emerald-400/20';
        if (action === 'DENY' || action === 'BLOCK' || action === 'BYPASS') return 'text-rose-300 bg-rose-400/10 border-rose-400/20';
        if (action === 'WARN' || action === 'CLOSE') return 'text-amber-300 bg-amber-400/10 border-amber-400/20';
        return 'text-cyan-300 bg-cyan-400/10 border-cyan-400/20';
    }

    public severityClass(severity: string) {
        if (severity === 'CRITICAL') return 'text-rose-300 bg-rose-400/10 border-rose-400/20';
        if (severity === 'HIGH') return 'text-orange-300 bg-orange-400/10 border-orange-400/20';
        return 'text-amber-300 bg-amber-400/10 border-amber-400/20';
    }
}

export default PageDashboardComponent;